module.exports = __webpack_public_path__ + "img/wolf_3.f8278b14.jpg";